export interface CopilotDTO {
  id: string;
  siteId: string;
  name: string;
  status: "draft" | "published" | "disabled";
  autonomyMode: "read_only" | "suggest" | "confirm" | "auto";
  draftConfig: Record<string, any>;
  publishedVersion: number;
  retentionDays: number;
}

export const autonomyOptions = [
  { value: "auto", label: "全自动（推荐）", detail: "默认连续完成任务，普通操作不再逐步询问用户" },
  { value: "read_only", label: "只读回答", detail: "只读页面与知识，不高亮、不点击、不填写" },
  { value: "suggest", label: "建议操作", detail: "可以高亮、滚动并说明步骤，不产生写入" },
  { value: "confirm", label: "逐步确认", detail: "执行写入前逐步询问，适合调试或受控场景" },
] as const;

export function copilotFormValues(copilot: CopilotDTO) {
  const config = copilot.draftConfig || {};
  return {
    name: copilot.name,
    autonomyMode: copilot.autonomyMode || "auto",
    retentionDays: copilot.retentionDays,
    role: config.identity?.role || "网站助手",
    tone: config.identity?.tone || "friendly",
    language: config.identity?.language || "auto",
    introduction: config.identity?.introduction || "你好，我可以帮你查找站内内容。",
    citations: config.answer?.citations || "when_available",
    unknownBehavior: config.answer?.unknownBehavior || "say_unknown",
    additionalInstructions: config.answer?.additionalInstructions || "",
    userFields: Array.isArray(config.userFields) ? config.userFields : ["locale", "role", "membership"],
    handoffEnabled: Boolean(config.handoff?.enabled),
    handoffChannel: config.handoff?.channel || "url",
    handoffTarget: config.handoff?.target || "",
    handoffLabel: config.handoff?.label || "联系人工",
  };
}

export function copilotUpdatePayload(values: Record<string, any>, previousConfig: Record<string, any>) {
  const config: Record<string, any> = {
    ...previousConfig,
    identity: { role: values.role, tone: values.tone, language: values.language, introduction: values.introduction },
    answer: { citations: values.citations, unknownBehavior: values.unknownBehavior, additionalInstructions: values.additionalInstructions || "" },
    userFields: values.userFields || [],
    handoff: { enabled: Boolean(values.handoffEnabled), channel: values.handoffChannel, target: values.handoffTarget || "", label: values.handoffLabel || "联系人工" },
    branding: { ...(previousConfig.branding || {}), forceAIGCLabel: true },
  };
  return {
    name: values.name,
    autonomyMode: values.autonomyMode,
    retentionDays: values.retentionDays,
    config,
  };
}
